exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locationsPage {\n  display: flex;\n  flex-grow: 1;\n  justify-content: space-around;\n  flex-wrap: wrap;\n  padding-top: 48px;\n  padding-bottom: 7rem; }\n\n@media screen and (max-width: 960px) {\n  .locationsPage {\n    padding: 0 4vw 7rem 4vw; } }\n", ""]);

// exports
